import * as CONST from './const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

const initState = {
  citiesList: [],
  cityById: { loading: false },
  cityMissionsAmbassadors: [],
  cityMissionsClents: [],
  cityPickupTime: [],
  cityInventories: [],
  errorMessage: '',
  filterCountry: null,
  filterStatus: CONST.CITY_FILTER_STATUS.ACTIVE,
  // A hash map of city ids -> data. Used for the metrics implementation but
  // can be used for anything else.
  cities: {},
}

export function city(state = initState, action) {
  switch (action.type) {
    case CONST.GET_CITY_INVENTORIES_SUCCESS:
      return {
        ...state,
        cityInventories: action.payload.cityInventories.map(
          normalizeInventoryItem,
        ),
      }

    case CONST.GET_CITY_MISSIONS_SUCCESS:
      return {
        ...state,
        cityMissions: action.payload.cityMissions,
        cityMissionsAmbassadors: action.payload.cityMissionsAmbassadors,
        cityMissionsClents: action.payload.cityMissionsClents,
      }

    case CONST.GET_CITY_PICKUP_TIME_SUCCESS:
      return {
        ...state,
        cityPickupTime: action.payload.cityPickupTime,
      }

    case CONST.CREATE_CITY_PICKUP_TIME_SUCCESS:
      return {
        ...state,
        cityPickupTime: action.payload,
      }

    case CONST.CITY_GET_CITIES_SUCCESS:
      return {
        ...state,
        citiesList: action.payload.cities,
      }

    case CONST.CITY_GET_CITIES_ERROR:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
      }

    case CONST.CITY_SET_FILTER_COUNTRY:
      return {
        ...state,
        filterCountry: action.payload.countryCode,
      }

    case CONST.CITY_SET_FILTER_STATUS:
      return {
        ...state,
        filterStatus: action.payload.status,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        filterCountry: initState.filterCountry,
        filterStatus: initState.filterStatus,
      }

    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      return {
        ...state,
        cities: {
          ...state.cities,
          ...(() => {
            var cityPlans = action.result.data.campaign.cityPlans.nodes
            var subObject = {}
            cityPlans.forEach(cityPlan => {
              subObject[cityPlan.city.id] = Object.assign(
                {},
                state[cityPlan.city.id],
                {
                  id: cityPlan.city.id,
                  name: cityPlan.city.name,
                  countryId: cityPlan.city.country.id,
                  lunchCheckInTime: cityPlan.city.lunchCheckInTime,
                  afternoonCheckInTime: cityPlan.city.afternoonCheckInTime,
                  teamLeaderEnabled: cityPlan.city.teamLeaderEnabled,
                  latitude: cityPlan.city.latitude,
                  longitude: cityPlan.city.longitude,
                  locationIds: cityPlan.city.locations.edges.map(
                    e => e.node.id,
                  ),
                  brandAmbassadorIds: cityPlan.city.brandAmbassadors.edges.map(
                    e => e.node.id,
                  ),
                },
              )
            })
            return subObject
          })(),
        },
      }
    }
    case CONST.UPDATE_CITY_BY_ID_GRAPH_QL:
      return {
        ...state,
        cityById: { loading: true, ...state.cityById },
      }

    case CONST.UPDATE_CITY_BY_ID_GRAPH_QL_SUCCESS:
      return {
        ...state,
        cityById: {
          loading: false,
          ...state.cityById,
          ...action.result.data.updateCitySettings.city,
        },
      }

    case CONST.UPDATE_CITY_BY_ID_GRAPH_QL_FAILURE:
      return {
        ...state,
        cityById: { loading: false, ...state.cityById },
      }

    default:
      return state
  }
}

/**
 * Normalizes the format returned from the server into objects that the client
 * can deal with
 * @param {object} dto
 * @returns {object}
 */
function normalizeInventoryItem(dto) {
  return {
    ambassador_id: dto.ambassadorId,
    client_id: dto.clientId,
    city_id: dto.cityId,
    item_type_id: dto.typeId,
    quantity: dto.quantity,
    description: dto.description,
    isLeftOver: dto.isLeftOver,
    id: dto.id,
    inventoryId: dto.inventoryId,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/City/reducer.js